import * as numeral from 'numeral';
var CURRENCY_CODE = {
    SG: 'S$',
    UK: '£',
    US: '$',
};
export var getCurrencyPrice = function (amount, options) {
    if (options === void 0) { options = { country: 'SG' }; }
    if (options.noCast) {
        return CURRENCY_CODE[options.country] + " " + amount;
    }
    else {
        return CURRENCY_CODE[options.country] + " " + numeral(Number(amount)).format('0,0.00');
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWF0SGVscGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL0hlbHBlcnMvZm9ybWF0SGVscGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxPQUFPLE1BQU0sU0FBUyxDQUFDO0FBRW5DLElBQU0sYUFBYSxHQUFHO0lBQ3BCLEVBQUUsRUFBRSxJQUFJO0lBQ1IsRUFBRSxFQUFFLEdBQUc7SUFDUCxFQUFFLEVBQUUsR0FBRztDQUNSLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxnQkFBZ0IsR0FBRyxVQUM5QixNQUFjLEVBQ2QsT0FHbUI7SUFIbkIsd0JBQUEsRUFBQSxZQUdLLE9BQU8sRUFBRSxJQUFJLEVBQUM7SUFFbkIsSUFBSSxPQUFPLENBQUMsTUFBTSxFQUFFO1FBQ2xCLE9BQVUsYUFBYSxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsU0FBSSxNQUFRLENBQUM7S0FDdEQ7U0FBTTtRQUNMLE9BQVUsYUFBYSxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsU0FBSSxPQUFPLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBRyxDQUFDO0tBQ3hGO0FBQ0gsQ0FBQyxDQUFDIn0=